import http from '@/support/plugin/axios'

export const 

//Pegar informações da compra
getSaleByCompanyIdAndUniqueId = (companyId, uniqueId) => http.get(`companies/${companyId}/sales?uniqueId=${uniqueId}`)